module.exports = __webpack_public_path__ + "img/trip-start.9097abbf.svg";